import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { type ReactNode, useState } from 'react'
import { type TransactionTabValue } from '../../utils/transactionStatusUtils'
import { TransactionFilterProvider } from '../../context/transactionFilterContext'
import { TransactionSelectionProvider } from '../../context/transactionSelectionContext'
import { TransactionFilterSidebar } from './TransactionFilterSidebar'
import { TransactionList } from './TransactionList'
import { TransactionTabs } from './TransactionTabs'

type TransactionSectionProps = {
  title?: string
  listLimit?: number | null
  showViewAllButton?: boolean
  toolbar?: ReactNode
  paperLayout?: boolean
}

export const TransactionSection = ({
  title,
  listLimit = 5,
  showViewAllButton = true,
  toolbar,
  paperLayout = true,
}: TransactionSectionProps) => {
  const [tabValue, setTabValue] = useState<TransactionTabValue>('open')

  const tabsAndList = (
    <TransactionFilterProvider>
      {listLimit === null ? (
        <TransactionSelectionProvider>
          {toolbar}
          <TransactionTabs
            value={tabValue}
            onChange={setTabValue}
            withTopMargin={Boolean(toolbar)}
          />
          <TransactionList
            selectedTab={tabValue}
            listLimit={listLimit}
            showViewAllButton={showViewAllButton}
          />
          <TransactionFilterSidebar />
        </TransactionSelectionProvider>
      ) : (
        <>
          {toolbar}
          <TransactionTabs
            value={tabValue}
            onChange={setTabValue}
            withTopMargin={Boolean(toolbar)}
          />
          <TransactionList
            selectedTab={tabValue}
            listLimit={listLimit}
            showViewAllButton={showViewAllButton}
          />
          <TransactionFilterSidebar />
        </>
      )}
    </TransactionFilterProvider>
  )

  if (paperLayout) {
    return (
      <Paper elevation={1} sx={{ p: 2 }}>
        {title && <Typography variant='h3'>{title}</Typography>}
        {tabsAndList}
      </Paper>
    )
  }

  return <Stack>{tabsAndList}</Stack>
}
